import { connect } from 'react-redux'
import ChatPreview from './component'

import * as selectors from 'modules/org/selectors'

const mapStateToProps = state => ({
  iconStyle: selectors.getIcon(state),
  color: selectors.getColor(state)
})

export default connect(mapStateToProps)(ChatPreview)



// WEBPACK FOOTER //
// ./src/layouts/ChatPreview/index.js